const FALLBACK_LOCAL_BACKEND = 'http://localhost:55000';

let cachedBackendBaseUrl = null;

const canUseWindow = typeof window !== 'undefined' && typeof window.location !== 'undefined';

const extractOrigin = (rawUrl) => {
  try {
    const baseForRelative = canUseWindow ? window.location.origin : FALLBACK_LOCAL_BACKEND;
    const parsed = new URL(rawUrl, baseForRelative);
    return `${parsed.protocol}//${parsed.host}`;
  } catch (error) {
    return null;
  }
};

export const getBackendBaseUrl = () => {
  if (cachedBackendBaseUrl) {
    return cachedBackendBaseUrl;
  }

  const envUrl = process.env.REACT_APP_API_URL;
  const originFromEnv = envUrl ? extractOrigin(envUrl) : null;
  if (originFromEnv) {
    cachedBackendBaseUrl = originFromEnv;
    return cachedBackendBaseUrl;
  }

  if (canUseWindow) {
    const { origin } = window.location;
    if (/localhost:(3000|53000)/.test(origin)) {
      cachedBackendBaseUrl = FALLBACK_LOCAL_BACKEND;
    } else {
      cachedBackendBaseUrl = origin;
    }
    return cachedBackendBaseUrl;
  }

  cachedBackendBaseUrl = FALLBACK_LOCAL_BACKEND;
  return cachedBackendBaseUrl;
};

export const buildImageUrl = (imagePath, { defaultPath = '/default-avatar.png' } = {}) => {
  if (!imagePath || typeof imagePath !== 'string' || imagePath.trim() === '') {
    return defaultPath;
  }

  const trimmedPath = imagePath.trim();

  if (trimmedPath === defaultPath) {
    return defaultPath;
  }

  if (trimmedPath.startsWith('data:') || trimmedPath.startsWith('blob:')) {
    return trimmedPath;
  }

  if (/^https?:\/\//i.test(trimmedPath)) {
    return trimmedPath;
  }

  if (trimmedPath.startsWith('/uploads')) {
    return `${getBackendBaseUrl()}${trimmedPath}`;
  }

  if (trimmedPath.startsWith('uploads/')) {
    return `${getBackendBaseUrl()}/${trimmedPath}`;
  }

  return trimmedPath;
};
